<template>
  <div class="order-history">
    <md-table-card>

      <md-toolbar>
        <md-layout class="list-header">

          <md-layout>
          </md-layout>

          <md-layout>
            <translate tag="h1" class="md-title">Order Archive</translate>
          </md-layout>

          <md-layout md-align="end">
            <translate class="sort-by">Sort by:</translate>
            <md-input-container class="sort-input">
              <md-select name="order-field" id="order-field" v-model="orderField">
                <md-option value="0">{{ trDate }}</md-option>
                <md-option value="1">{{ trTotalPrice }}</md-option>
                <md-option value="2">{{ trCustomerId }}</md-option>
                <md-option value="3">{{ trEmail }}</md-option>
                <md-option value="4">{{ trName }}</md-option>
              </md-select>
            </md-input-container>

            <md-input-container class="sort-input">
              <md-select name="order-direction" id="order-direction" v-model="direction">
                <md-option value="0">{{ trAscending }}</md-option>
                <md-option value="1">{{ trDescending }}</md-option>
              </md-select>
            </md-input-container>

            <!-- <md-button class="md-icon-button">
              <md-icon>search<md-tooltip><translate>Search for order</translate></md-tooltip></md-icon>
            </md-button> -->
            <md-button @click.native="fetchOrders()" class="md-icon-button">
              <md-icon>refresh<md-tooltip><translate>Refresh orders</translate></md-tooltip></md-icon>
            </md-button>
          </md-layout>
        </md-layout>
      </md-toolbar>
    <md-card-area class="card-area">
      <order-card v-for="(order, index) in ordersComputed" :order="order" :key="order.orderId" :index="index"></order-card>
    </md-card-area>

  </md-table-card>
</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import OrderCard from '../../order/Card'
import orderBy from 'lodash.orderby'

export default {
  name: 'order-list',
  data () {
    return {
      orderField: '0',
      direction: '0'
    }
  },
  async created () {
    await this.fetchOrders()
  },
  watch: {
    language (lang) {
      this.onChangeLang(this.direction, this.orderField)
    }
  },
  computed: {
    ordersComputed () {
      let field
      if (this.orderField === '0') {
        field = 'dateRaw'
      } else if (this.orderField === '1') {
        field = 'totalPrice'
      } else if (this.orderField === '2') {
        field = 'customer'
      } else if (this.orderField === '3') {
        field = 'email'
      } else {
        field = 'name'
      }
      let direction
      if (this.direction === '0') {
        direction = 'asc'
      } else {
        direction = 'desc'
      }
      return orderBy(this.allOrders, field, direction)
    },
    trDate () {
      return this.$gettext('Date')
    },
    trTotalPrice () {
      return this.$gettext('Total Price')
    },
    trCustomerId () {
      return this.$gettext('Depot')
    },
    trEmail () {
      return this.$gettext('E-mail')
    },
    trName () {
      return this.$gettext('Name')
    },
    trAscending () {
      return this.$gettext('Ascending')
    },
    trDescending () {
      return this.$gettext('Descending')
    },
    language () {
      return this.$language.current
    },
    ...mapGetters([
      'allOrders'
    ])
  },
  methods: {
    onChangeLang (dir, field) {
      // force fields to change ...
      this.direction = toString((parseInt(dir) + 1) % 2)
      this.orderField = toString((parseInt(dir) + 1) % 5)

      Vue.nextTick(() => {
        // ... and change them back to original values
        this.direction = dir
        this.orderField = field
      })
    },
    ...mapActions([
      'fetchOrders'
    ])
  },
  components: {
    OrderCard
  }
}
</script>

<style scoped>
.card-area {
  padding: 8px;
}
.order-history div.md-card {
  box-shadow: none;
}
.sort-input {
  display: inline !important;
  width: auto;
  min-height: 40px;
  padding: 4px 0px 0px 0px;
  margin: 0px;
}
.sort-by {
  line-height: 40px;
}
/*span.md-select-value {
  line-height: 40px !important;
}*/
.list-header h1 {
  line-height: 40px;
  font-size: 1.6em;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/orders/List.vue